/* eslint-disable no-use-before-define */
import React, { useMemo, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import { ClassType } from '../../api';
import { LineupEntry } from '../../services/sessionModels';

interface Props {
  value: LineupEntry | null | undefined;
  label?: string;
  exclude?: Array<number>;
  lineup?: Array<LineupEntry> | undefined | null;
  classType?: ClassType;
  onChange: (lineupEntry: LineupEntry | null) => void;
}

export const displayName = (lineupEntry: LineupEntry) => {
  const name = lineupEntry.player?.name ?? '';
  return lineupEntry.shirtNumber ? `${lineupEntry.shirtNumber}. ${name}` : name;
};

type OptionType = LineupEntry & { inputValue?: string };
const filter = createFilterOptions<OptionType>({ stringify: displayName });

const SelectSingleLineupEntry: React.FunctionComponent<Props> = React.memo(
  ({ value, label, exclude, onChange, lineup, classType }) => {
    const [inputValue, setInputValue] = useState('');

    const selected = useMemo(() => {
      return (lineup?.find((d) => value && d.id === value.id) as LineupEntry) || null;
    }, [lineup, value]);

    const sortedData = useMemo(() => {
      return (
        lineup
          ?.slice()
          .filter((l) => l.type === classType)
          .sort((l1, l2) => l1.shirtNumber - l2.shirtNumber)
          .sort((l1, l2) => (l1.inSeconds ?? 0) - (l2.inSeconds ?? 0)) || []
      );
    }, [classType, lineup]);

    return (
      <React.Fragment>
        <Autocomplete
          value={selected}
          onChange={(event, newValue) => {
            onChange(newValue as LineupEntry);
          }}
          inputValue={inputValue}
          onInputChange={(event, newInputValue) => {
            setInputValue(newInputValue);
          }}
          filterOptions={(options, params) => {
            const filtered = filter(options, params);
            return filtered;
          }}
          id="Player-autocomplete"
          options={sortedData as OptionType[]}
          getOptionDisabled={(option) => !!exclude && exclude.includes(option.id)}
          getOptionLabel={(option) => {
            return displayName(option);
          }}
          groupBy={(option) =>
            !option.inSeconds ? 'Starting lineup' : 'Substitution ' + Math.floor(option.inSeconds / 60) + "'"
          }
          selectOnFocus
          clearOnBlur
          handleHomeEndKeys
          style={{ marginTop: 16, marginBottom: 8 }}
          freeSolo={false}
          renderInput={(params) => <TextField {...params} label={label || 'Player'} variant="standard" />}
        />
      </React.Fragment>
    );
  }
);

export default SelectSingleLineupEntry;
